import { AlertCircle, CheckCircle, Info, AlertTriangle, X } from 'lucide-react';
import { Button } from './Button';

export type AlertVariant = 'success' | 'error' | 'warning' | 'info';

interface AlertProps {
  variant: AlertVariant;
  title?: string;
  message: string;
  onClose?: () => void;
  className?: string;
}

const iconMap = {
  success: CheckCircle,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
};

const variantClasses = {
  success: 'border-success/30 bg-success/10 text-success',
  error: 'border-error/30 bg-error/10 text-error',
  warning: 'border-warning/30 bg-warning/10 text-warning',
  info: 'border-primary/30 bg-primary/10 text-primary',
};

export function Alert({ variant, title, message, onClose, className = '' }: AlertProps) {
  const Icon = iconMap[variant];

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border p-4 ${variantClasses[variant]} ${className}`}
      role="alert"
    >
      <Icon className="mt-0.5 h-5 w-5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        {title && <p className="font-semibold text-foreground mb-1">{title}</p>}
        <p className={`text-sm ${title ? 'text-foreground-muted' : 'text-foreground'}`}>{message}</p>
      </div>
      {onClose && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="flex-shrink-0 -mr-1 -mt-1"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
